/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=45d0847d"
const script = {}

import "./App.vue?vue&type=style&index=0&id=45d0847d&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__